import { useState } from "react";
import { useSchedule } from "@/context/ScheduleContext";
import { formatWib } from "@/lib/wib";
import RangeCalendar from "@/components/RangeCalendar";
import ResponsiveFormDialog from "@/components/ResponsiveFormDialog";

/**
 * Ringkasan jadwal bersama + satu pintu edit (dialog kalender bersama).
 * Dipakai katalog (pasca-komit), detail, dan checkout.
 */
export default function ScheduleStrip({ onChanged }) {
  const sched = useSchedule();
  const [open, setOpen] = useState(false);
  const [trigger, setTrigger] = useState(null);

  const openDialog = (e) => {
    setTrigger(e?.currentTarget ?? document.activeElement);
    setOpen(true);
  };
  const closeDiscard = () => {
    setOpen(false);
    // Draft kalender lokal dibuang otomatis (tidak ada persist tanpa Apply).
    // Kembalikan fokus ke pemicu seperti kontrak dialog.
    setTimeout(() => {
      if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
    }, 0);
  };
  const apply = (next) => {
    sched.patch(next);
    setOpen(false);
    onChanged?.();
    setTimeout(() => {
      if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
    }, 0);
  };

  return (
    <>
      <section aria-label="Jadwal peminjaman" className="rounded-xl border border-slate-200 bg-white p-2.5 sm:p-4">
        {sched.ok ? (
          <p className="text-[13px] leading-snug text-slate-500 sm:text-sm">
            Jadwal: <strong className="text-slate-900">{formatWib(sched.startMs)}</strong>
            {" → "}
            <strong className="text-slate-900">{formatWib(sched.endMs)}</strong>
          </p>
        ) : (
          <p className="text-sm text-slate-500">
            Belum ada jadwal. Stok yang tampil adalah stok total.
          </p>
        )}
        <div className="mt-2 flex flex-wrap gap-2">
          <button type="button" onClick={openDialog}
            className="min-h-[44px] rounded-lg border border-slate-300 bg-white px-3 py-2 text-[13px] font-semibold text-slate-900 transition-colors hover:border-slate-900">
            Ubah jadwal
          </button>
          {sched.draft.pickup_date && (
            <button type="button" onClick={() => { sched.clear(); onChanged?.(); }}
              className="min-h-[44px] rounded-lg px-3 py-2 text-[13px] font-semibold text-[#004f9e] transition-colors hover:underline">
              Hapus jadwal
            </button>
          )}
        </div>
      </section>
      <ResponsiveFormDialog open={open} onOpenChange={(v) => { if (!v) closeDiscard(); }}
        tone="light" title="Pilih rentang tanggal (WIB)"
        description={sched.ok ? `Jadwal aktif saat ini: ${formatWib(sched.startMs)} → ${formatWib(sched.endMs)}.` : undefined}>
        <RangeCalendar key={open ? "open" : "closed"} initial={sched.draft}
          submitLabel="Terapkan rentang" showCommitted={false}
          onApply={apply} onCancel={closeDiscard} />
      </ResponsiveFormDialog>
    </>
  );
}
